import { useContext } from 'react';
import { ApisContext } from './ApisContext';

export const useAuth0Api = () => {
  const { auth0API } = useContext(ApisContext);

  return auth0API;
};
